/**
 * Graphite chrome icons — a small inline-SVG set so the header + sidebar carry
 * no icon-font dependency and inherit colour from their parent (currentColor).
 * Outline style, 24-grid, 1.7 stroke — matches the Apple-clean aesthetic.
 */
import React from 'react';

const PATHS: Record<string, string> = {
  menu:      'M4 6h16M4 12h16M4 18h16',
  close:     'M6 6l12 12M18 6L6 18',
  job:       'M4 7h16v12H4z M9 7V5h6v2 M4 13h16',
  cust:      'M15 19v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1 M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6 M19 8v6 M22 11h-6',
  cal:       'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z M3 9h18 M8 3v4 M16 3v4',
  lock:      'M6 11h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1z M8 11V8a4 4 0 0 1 8 0v3',
  chat:      'M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z',
  leads:     'M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0 M3 12h18 M12 3a15 15 0 0 1 0 18 M12 3a15 15 0 0 0 0 18',
  mail:      'M3 5h18v14H3z M3 6l9 7 9-7',
  andrei:    'M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z M18.5 14l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z',
  approve:   'M9 12l2 2 5-5 M21 12v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11',
  access:    'M14 7a3 3 0 1 1-2.83 4H8v2H6v2H3v-3l5.17-5.17A3 3 0 0 1 14 7z M15 9h.01',
  dashboard: 'M4 4h7v7H4z M13 4h7v4h-7z M13 11h7v9h-7z M4 13h7v7H4z',
  chart:     'M4 19V5 M4 19h16 M8 16v-5 M12 16V8 M16 16v-3',
  megaphone: 'M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z M15 8a4 4 0 0 1 0 8',
  globe:     'M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0 M3 12h18 M12 3a15 15 0 0 1 0 18',
  users:     'M15 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1 M8.5 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6 M22 19v-1a4 4 0 0 0-3-3.87',
  receipt:   'M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5V3z M9 8h6 M9 12h6',
  wallet:    'M3 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M3 10h18 M16 14h2',
  bank:      'M4 10h16 M12 4L4 9h16z M6 10v8 M10 10v8 M14 10v8 M18 10v8 M4 20h16',
  settings:  'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z M19.4 13a7.5 7.5 0 0 0 0-2l1.8-1.4-1.8-3.1-2.1.9a7.5 7.5 0 0 0-1.7-1L15 4h-3.6l-.4 2.4a7.5 7.5 0 0 0-1.7 1l-2.1-.9L3.4 9.6 5.2 11a7.5 7.5 0 0 0 0 2l-1.8 1.4 1.8 3.1 2.1-.9a7.5 7.5 0 0 0 1.7 1l.4 2.4H15l.4-2.4a7.5 7.5 0 0 0 1.7-1l2.1.9 1.8-3.1z',
  logout:    'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9',
  search:    'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
  theme:     'M12 3a9 9 0 1 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.4-1-.24-.27-.39-.62-.39-1 0-.83.67-1.5 1.5-1.5H16a4 4 0 0 0 4-4c0-4.42-3.58-8-8-8z M7.5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2 M10.5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2 M15 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
};

export const Icon: React.FC<{ name: string; size?: number; className?: string }> = ({ name, size = 18, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={PATHS[name] || ''} />
  </svg>
);

export default Icon;
